import { PermissionType } from '@cbinsights/adminpermissionservice/adminpermissionservice';
import { useGetAdminPermissionsForUser } from './UseGetAdminPermissionsForUserQuery';

export const useHasAccess = ({
  pageId,
  permissionType,
}: {
  pageId: number;
  permissionType: PermissionType;
}): boolean => {
  const { data } = useGetAdminPermissionsForUser();

  const pageInformation = data?.adminPages?.filter(
    (el) => el.idAdminPage === pageId
  )[0];

  const hasPageAccess = pageInformation.permissionTypes.filter(
    (permission) => permission === permissionType
  );

  return hasPageAccess.length > 0;
};

export default useHasAccess;
